import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-custom mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pb-0" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "d-flex align-items-center pb-4" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-45px symbol-light me-5\"><span class=\"symbol-label align-items-end\"><img alt=\"Logo\" src=\"media/svg/avatars/018-girl-9.svg\" class=\"mh-40px\"></span></div><div class=\"d-flex flex-column flex-grow-1\"><a href=\"#\" class=\"text-gray-800 text-hover-primary mb-1 fs-6 fw-bolder\">Grace Logan</a><span class=\"text-muted fw-bold\">Yestarday at 5:06 PM</span></div>", 2)
const _hoisted_7 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-800 fs-6 fw-normal" }, " Outlines keep you honest. They stop you from indulging in poorly thought-out metaphors about driving and keep you focused on the overall structure of your post ", -1)
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = {
  href: "#",
  class: "btn btn-sm btn-color-muted btn-active-light-primary fw-bolder"
}
const _hoisted_12 = { class: "svg-icon svg-icon-3 pe-2" }
const _hoisted_13 = {
  href: "#",
  class: "btn btn-sm btn-color-muted btn-active-light-danger fw-bolder"
}
const _hoisted_14 = { class: "svg-icon svg-icon-3 pe-1" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex py-5\"><div class=\"symbol symbol-40px me-5\"><span class=\"symbol-label bg-light align-items-end\"><img alt=\"Logo\" src=\"media/svg/avatars/009-boy-4.svg\" class=\"mh-35px\"></span></div><div class=\"d-flex flex-column flex-row-fluid\"><div class=\"d-flex align-items-center flex-wrap\"><a href=\"#\" class=\"text-gray-800 text-hover-primary mb-1 fs-6 fw-bolder pe-6\">Mr. Anderson</a><span class=\"text-muted fw-normal flex-grow-1 fs-7\">1 Day ago</span><a href=\"#\" class=\"text-muted text-hover-primary fw-normal fs-7\">Reply</a></div><span class=\"text-gray-800 fs-7 fw-normal pt-1\"> Long before you sit dow to put digital pen to paper you need to make sure you have to sit down and write. </span></div></div><div class=\"d-flex\"><div class=\"symbol symbol-40px me-5\"><span class=\"symbol-label bg-light align-items-end\"><img alt=\"Logo\" src=\"media/svg/avatars/003-girl-1.svg\" class=\"mh-35px\"></span></div><div class=\"d-flex flex-column flex-row-fluid\"><div class=\"d-flex align-items-center flex-wrap\"><a href=\"#\" class=\"text-gray-800 text-hover-primary mb-1 fs-6 fw-bolder pe-6\">Mrs. Anderson</a><span class=\"text-muted fw-normal flex-grow-1 fs-7\">2 Days ago</span><a href=\"#\" class=\"text-muted text-hover-primary fw-normal fs-7\">Reply</a></div><span class=\"text-gray-800 fs-7 fw-normal pt-1\"> Long before you sit down to put digital pen to paper </span></div></div>", 2)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"separator mt-5\"></div><form class=\"position-relative py-4 d-flex align-items-center pb-5\"><textarea id=\"kt_forms_widget_4_input\" class=\"form-control min-h-auto border-0 p-0 pe-10 resize-none\" rows=\"1\" placeholder=\"Reply...\"></textarea><div class=\"position-absolute top-0 end-0 mt-2 me-n3\"><span class=\"btn btn-icon btn-sm btn-active-color-primary\"><i class=\"fas fa-paperclip fs-6\"></i></span><span class=\"btn btn-icon btn-sm btn-active-color-primary\"><i class=\"fas fa-map-marker-alt fs-6\"></i></span></div></form>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
            ])
          ]),
          _createVNode(_component_Dropdown3)
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
              ]),
              _createTextVNode(" 24 ")
            ]),
            _createElementVNode("a", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen030.svg" })
              ]),
              _createTextVNode(" 75 ")
            ])
          ]),
          _hoisted_15
        ])
      ]),
      _hoisted_17
    ])
  ]))
}